




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

export enum StepsContentSize {
  Auto = 'steps--auto-content',
  Max = 'steps--max-content',
}

@Component({
  components: {},
})
export default class Steps extends Vue {
  @Prop({ default: 1 }) private steps!: number;
  @Prop({ default: 1 }) private activeStep!: number;
  @Prop({ default: StepsContentSize.Auto })
  private contentSize!: StepsContentSize;

  private stepChanged = false;

  private created() {
    this.changeStep(this.activeStep);
  }

  @Watch('activeStep')
  private watchActiveStep(newVal: number, oldVal: number) {
    this.changeStep(newVal);
    this.activeStepChanged();
  }

  private slotName(step: number, termination: string = '') {
    return `step-${step}${termination}`;
  }

  private isSelected(step: number) {
    return step === this.activeStep;
  }

  private isActive(step: number) {
    return step <= this.activeStep;
  }

  private activeStepChanged() {
    this.stepChanged = true;
    setTimeout(() => {
      this.stepChanged = false;
    }, 0);
  }

  private changeStep(step: number) {
    this.$emit('input', step);
  }
}
